<template>
  <div style="background:#f6f7fa;">
    <Header></Header>

    <div class="container mt-4">
      <div class="row bg-white pt-3 pb-3">
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12" style="height:240px;">
          <!-- <video width="100%" height="240" controls="controls">
            <source src="movie.mp4" type="video/mp4" />
            <source src="movie.ogg" type="video/ogg" />
            <source src="movie.webm" type="video/webm" />
            <object data="movie.mp4" width="320" height="240">
              <embed src="movie.swf" width="320" height="240" />
            </object>
          </video>-->
          <iframe
            id="video"
            :src="videoSrc"
            frameborder="no"
            border="0"
            marginwidth="0"
            marginheight="0"
            scrolling="no"
            allowtransparency="yes"
            allowfullscreen="allowfullscreen"
            data-mce-fragment="1"
            width="100%"
            height="100%"
          ></iframe>
        </div>
        <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 pl-2 pr-2">
          <h4 class="mb-0 text-body p-1 cTit">{{bookInfo.title?bookInfo.title:'未知书名'}}</h4>
          <ul class="list-unstyled">
            <li class="text-muted p-1">作者：{{bookInfo.author?bookInfo.author:'未知作者'}}</li>
            <li class="text-muted p-1">单位：{{bookInfo.editor?bookInfo.editor:'未知单位'}}</li>
            <!-- <li class="text-muted p-1 intro">曾在《光明日报》《经济社会体制比较》《中国行政管理》《社会》等权威报刊上发表文章数十篇。出版专著《国家回归：社会福利责任结构的再平衡》《中国社会福利体系转型中的国家责任研究》。主持多项国家社科基金和省部级科研项目，长期参与中央与国家部委委托项目、地方政府的政策制定与政策评估。 </li> -->
            <!-- <div v-html="bookDesc"></div> -->

            <li class="text-muted p-1">
              <div v-html="bookInfo.desc"></div>
            </li>
            <router-link :to="intoUrl">
              <button type="button" class="btn btn-primary mt-1 pl-4 pr-4">进入学习</button>
            </router-link>
          </ul>
        </div>
        <div class="col-auto d-none d-lg-block"></div>
      </div>
    </div>

    <div class="container mt-2">
      <div class="row">
        <div class="col-lg-9 col-md-9 col-sm-8 col-xs-12">
          <div class="cTab col-12 text-center">
            <a
              :class="contentId === '02' ? 'cur' : ''"
              class="p-2 ml-1 mr-1 text-secondary"
              @click="() => getChap('02')"
            >授课教师</a>
            <a
              :class="contentId === '03' ? 'cur' : ''"
              class="p-2 ml-1 mr-1 text-secondary"
              @click="() => getChap('03')"
            >课程详情</a>
            <a
              :class="contentId === '04' ? 'cur' : ''"
              class="p-2 ml-1 mr-1 text-secondary"
              @click="() => getChap('04')"
            >大纲目录</a>
            <a
              :class="contentId === '05' ? 'cur' : ''"
              class="p-2 ml-1 mr-1 text-secondary"
              @click="() => getChap('05')"
            >资料区</a>
          </div>
          <div class="cTab2 col-12 text-center w-100">
            <a
              class="p-2 ml-1 mr-1 text-secondary"
              :class="contentId === '02' ? 'cur' : ''"
              @click="() => getChap('02')"
            >教师</a>
            <a
              class="p-2 ml-1 mr-1 text-secondary"
              :class="contentId === '03' ? 'cur' : ''"
              @click="() => getChap('03')"
            >详情</a>
            <a
              class="p-2 ml-1 mr-1 text-secondary"
              :class="contentId === '04' ? 'cur' : ''"
              @click="() => getChap('04')"
            >大纲</a>
            <a
              class="p-2 ml-1 mr-1 text-secondary"
              :class="contentId === '05' ? 'cur' : ''"
              @click="() => getChap('05')"
            >资料</a>
          </div>
          <div class="bg-white p-4 justify tabContent">
            <div class="mx-auto" v-if="contentId === '02'">
              <div v-html="teacherInfo02"></div>
            </div>
            <div class="mx-auto" v-if="contentId === '04'">
              <div v-html="courseDetail04"></div>
            </div>
            <div class="mx-auto" v-if="contentId === '03'">
              <div v-html="dir03"></div>
            </div>
            <div v-if="contentId === '05' && zls.length>0">
              <div v-for="(item,index) in zls" :key="index" class="zlBox">
                <div>{{item.title}}</div>
                <i
                  class="el-icon-download cPointer"
                  @click="()=>handleDownLoad(item.id)"
                  v-if="item.qiniuFileMeta"
                  style="color:#007bff;"
                ></i>
                <div v-else style="color:#888;font-size:12px;">暂无地址</div>
              </div>

              <!-- <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="author" label="作者" width="150"></el-table-column>
                <el-table-column prop="updateTime" label="上传时间" width="200"></el-table-column>
                <el-table-column prop="handle" label="操作" fixed="right" width="120">
                  <template slot-scope="scope">
                    <el-button size="mini" plain @click="handleEdit(scope.$index, scope.row)">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>-->
            </div>
            <div v-if="contentId === '05' && zls.length===0">暂无</div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
          <div class="cTabr col-12 text-center">
            <span href="#" class="p-2 ml-1 mr-1">相关推荐</span>
          </div>
          <div class="bg-white p-4 cList cList2">
            <ul class="list-unstyled" v-for="(item, index) in recommended" :key="index">
              <router-link :to="'/course/'+item._id+ '?tags=' + item.tags">
                <li>
                  <img :src="item.bookImg" class="rounded-top cImg" alt="..." />
                </li>
                <li>
                  <a class="bd-content-title" style="color:#000;">{{ item.title }}</a>
                </li>
                <li class="text-secondary">{{ item.editor ? item.editor : "未知单位" }}</li>
                <li class="text-secondary">{{ item.author ? item.author : "未知作者" }}</li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>
<script>
import {
  getResources,
  getBooks,
  getProtectContent,
  getBookDetail
} from "../api";
import Header from "../components/header";
import Bottom from "../components/bottom";
export default {
  data() {
    return {
      contentId: "02",
      // tableData: [],
      bookImg: require("../assets/img/default.jpg"),
      bookId: "",
      chapter: "",
      video01: "",
      teacherInfo02: "",
      dir03: "",
      courseDetail04: "",
      afterSchoolWork05: "",
      // bookInfo: {},
      bookTitle: "",
      bookDesc: "",
      videoSrc: "",
      intoUrl: "",
      recommended: [],
      zls: [],
      bookInfo: {}
    };
  },
  components: {
    Header,
    Bottom
  },
  created() {
    this.bookId = this.$route.params.ID;
    this.intoUrl = "/resource/" + this.$route.params.ID;

    getResources(this.bookId, { chapter: "01" }).then(res => {
      if (res.success && res.rows[0]) {
        this.bookDesc = res.rows[0].desc || "";
        this.videoSrc = "https://2d.hep.com.cn/iframe/" + res.rows[0].id;
      }
    });
    this.getResource("02");
    this.getBooks();
    getBookDetail(this.bookId).then(data => {
      if (data.data) {
        this.bookInfo = data.data;
      }
    });
  },
  methods: {
    getBooks() {
      let arr = [];
      getBooks({ tags: this.$route.query.tags }).then(res => {
        if (res.success) {
          res.rows.forEach(item => {
            getResources(item.id, { chapter: "07" }).then(res => {
              if (res.success && res.rows.length > 0) {
                arr.push({
                  bookImg: res.rows[0].qiniuFileMeta.coverUrl,
                  title: item.title,
                  editor: item.editor,
                  author: item.author,
                  _id: item._id,
                  tags: item.tags[0]
                });
              } else {
                arr.push({
                  bookImg: this.bookImg,
                  title: item.title,
                  editor: item.editor,
                  author: item.author,
                  _id: item._id,
                  tags: item.tags[0]
                });
              }
              this.recommended = arr;
            });
          });
        }
      });
    },
    handleDownLoad(id) {
      getProtectContent(this.bookId, id).then(res => {
        if (res.success || res.data.download) {
          // window.location.href = res.data.download;
          window.open(res.data.download);
        }
      });
    },
    getResource(param) {
      getResources(this.bookId, { chapter: param }).then(res => {
        // [0] video 和book的描述
        // this.bookTitle = res.rows[13].book.title || "";
        // if(res.rows)
        // let count = res.rows.length;
        // if (res.success && res.rows.length > 5) {
        //   // this.bookDesc = res.rows[count - 1].desc || "";
        //   // this.videoSrc =
        //   //   "https://2d.hep.com.cn/iframe/" + res.rows[count - 1].id;
        //   this.teacherInfo02 = res.rows[count - 2].desc || "暂无";
        //   this.courseDetail04 = res.rows[count - 3].desc || "暂无";
        //   this.dir03 = res.rows[count - 4].desc || "暂无";
        //   // this.dir03 = res.rows[count - 3].desc || "";
        //   // this.courseDetail04 = res.rows[count - 4].desc || "";
        //   this.zl05 = res.rows[count - 5].desc || "暂无";
        //   this.zlIds = res.rows[count - 5].id;
        //   getProtectContent(this.bookId, this.zlIds).then(res => {
        //     console.log(res);
        //   });
        // } else {
        //   this.teacherInfo02 = "暂无";
        //   this.courseDetail04 = "暂无";
        //   this.dir03 = "暂无";
        //   // this.dir03 = res.rows[count - 3].desc || "";
        //   // this.courseDetail04 = res.rows[count - 4].desc || "";
        //   this.zl05 = "暂无";
        // }
        // console.log(res);
        if (res.success) {
          if (res.total > 0) {
            switch (res.rows[0].chapter) {
              case "02":
                this.teacherInfo02 = res.rows[0].desc || "暂无";
                break;
              case "03":
                this.dir03 = res.rows[0].desc || "暂无";
                break;
              case "04":
                // console.log("res of 04", res.rows);
                this.courseDetail04 = res.rows[0].desc || "暂无";
                break;
              case "05":
                // if (res.rows[0].desc) {
                //   this.zl05 = res.rows[0].title;
                //   this.zlId = res.rows[0].id;
                // } else {
                //   this.zl05 = "暂无";
                //   this.canDownload = false;
                // }
                this.zls = res.rows;
                // console.log(this.zls);
                break;
            }
          } else {
            this.teacherInfo02 = "暂无";
            this.courseDetail04 = "暂无";
            this.dir03 = "暂无";
            this.zls = [];
          }
        }
      });
    },
    getChap(param) {
      this.contentId = param;
      // this.chapter = param;
      this.getResource(param);
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  }
};
</script>
<style scoped>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
a {
  cursor: pointer;
}
.justify {
  text-align: justify;
}
div p {
  cursor: pointer;
}
.cPointer {
  cursor: pointer;
}
.zlBox {
  display: inline-flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}
</style>
